export default {
  alertPersonalHeader: {
    ticker: 'Mã',
    alertName: 'Cảnh Báo',
    activate: 'Kích Hoạt',
    action: 'Hành động',
  },
  confirmDel: {
    title: 'Gỡ cảnh báo',
    content: 'Bạn muốn gỡ bỏ cảnh báo này?',
  },
  editSetting: {
    email: 'Email',
    notifications: 'Thông Báo',
    notificationPreferences: 'Nhận Thông Báo Qua',
    conditions: 'Điều Kiện',
    applyTo: 'Áp dụng cho: %{ticker}',
  },
  deleteAlert: 'Xóa cảnh báo này ?',
  delete: 'Xóa',
  cancel: 'Hủy',
};
